<template>
  <div class="main-wrap">
    <location :content-nav-list="contentNavList"></location>
    <div
      v-if="materialArticlesInfo?.currentMaterial?.status == WebsiteStatus.已发布"
      class="detail-title-container"
    >
      <div class="detail-title-container-title">
        {{ materialArticlesInfo.currentMaterial.title }}
      </div>
      <div class="detail-title-container-time">
        <div class="time"></div>

        {{
          materialArticlesInfo.currentMaterial.publishTime
            ? formatDate(materialArticlesInfo.currentMaterial.publishTime)
            : materialArticlesInfo.currentMaterial.publishTime
        }}
        <div class="read-count"></div>
        {{ materialArticlesInfo.currentMaterial.readCount }}
      </div>
      <div class="detail-title-container-digest">
        【摘要】：{{ materialArticlesInfo.currentMaterial.digest }}
      </div>
    </div>
    <div
      v-if="materialArticlesInfo?.currentMaterial?.status == WebsiteStatus.已发布"
      class="detail-content-container"
    >
      <ArticleContent
        :content="materialArticlesInfo.currentMaterial.content"
        :attachment-file-list="
          materialArticlesInfo.currentMaterial.attachmentFileList
        "
      />
    </div>
    <div
      v-if="materialArticlesInfo?.currentMaterial?.status == WebsiteStatus.已发布"
      class="detail-pager-container"
    >
      <span
        v-if="materialArticlesInfo && materialArticlesInfo.previousMaterial"
        class="detail-pager-container-pre"
        >上一篇：<a :href="materialArticlesInfo.previousMaterial.url">{{
          materialArticlesInfo.previousMaterial.title
        }}</a>
      </span>
      <span class="detail-pager-container-blank"></span>
      <span
        v-if="materialArticlesInfo && materialArticlesInfo.nextMaterial"
        class="detail-pager-container-next"
        >下一篇：
        <a :href="materialArticlesInfo.nextMaterial.url + ''">{{
          materialArticlesInfo.nextMaterial.title
        }}</a>
      </span>
    </div>
  </div>
  <div
    v-if="!materialArticlesInfo?.currentMaterial || materialArticlesInfo.currentMaterial.status != WebsiteStatus.已发布"
    class="no-content"
  >
    <el-empty class="empty-img" description="该文章未发布" />
  </div>
</template>
<script setup>
// #region 引用

import ArticleContent from '@/views/components/website/article-content/ArticleContent.vue';
import { WebsiteStatus } from '@/configs/enums/website';
import useSSRInitialStateStore from '@/stores/ssr-state';
import { useSSRContext } from '@/ssr/use-context';
import { getMaterialPageUrlForWebsite } from '@/utils/business/website';
import { formatDate } from '@/utils/common/date-util';
import location from '../components/Location.vue';
// #endregion

// #region props/emit

// #endregion

// #region 变量/常量

const configInfo = ref(); // 配置信息
const configPageList = ref(); // 配置页面列表
// 栏目信息
const columnInfo = ref();
// 栏目信息
const materialArticlesInfo = ref({});
const viewType = ref();
const previewId = ref();
// 导航地址信息
const contentNavList = ref([]);
const route = useRoute();
// #endregion

// #region 生命周期

// #endregion

// #region 业务方法

/**
 * 获取栏目内容缓存内容
 */

onServerPrefetch(async () => {
  const ssrContext = useSSRContext();
  configInfo.value = ssrContext.initialState?.data?.current?.configInfo;
  configPageList.value = ssrContext.initialState?.data?.current?.configPageList;
  columnInfo.value = ssrContext.initialState?.data?.current?.columnInfo;
  viewType.value = ssrContext.initialState?.data?.current?.viewType;
  previewId.value = ssrContext.initialState?.data?.current?.previewId;
  materialArticlesInfo.value =
    ssrContext.initialState?.data?.current?.materialArticlesInfo;
  contentNavList.value.push({
    title: '正文',
    url: getMaterialPageUrlForWebsite(
      route.params.columnId,
      route.params.materialId,
      viewType.value,
      previewId.value,
    ),
  });
  if (ssrContext.initialState?.data?.current) {
    ssrContext.initialState.data.current.contentNavList = contentNavList.value;
  }

  if (
    materialArticlesInfo.value &&
    materialArticlesInfo.value.previousMaterial
  ) {
    materialArticlesInfo.value.previousMaterial.url =
      getMaterialPageUrlForWebsite(
        route.params.columnId,
        materialArticlesInfo.value.previousMaterial.id,
        viewType.value,
        previewId.value,
      );
  }
  if (materialArticlesInfo.value && materialArticlesInfo.value.nextMaterial) {
    materialArticlesInfo.value.nextMaterial.url = getMaterialPageUrlForWebsite(
      route.params.columnId,
      materialArticlesInfo.value.nextMaterial.id,
      viewType.value,
      previewId.value,
    );
  }
  if (ssrContext.initialState?.data?.current) {
    ssrContext.initialState.data.current.materialArticlesInfo =
      materialArticlesInfo.value;
  }
});

// #endregion

// #region 客户端
// 客户端数据恢复 - 必须在 useHead 之前，否则会覆盖 SSR 标题
if (!import.meta.env.SSR) {
  const ssrInitialState = useSSRInitialStateStore();
  configInfo.value = ssrInitialState.data.current.configInfo;
  configPageList.value = ssrInitialState.data.current.configPageList;
  columnInfo.value = ssrInitialState.data.current.columnInfo;
  materialArticlesInfo.value =
    ssrInitialState.data.current.materialArticlesInfo;
  contentNavList.value = ssrInitialState.data.current.contentNavList;
  viewType.value = ssrInitialState.data.current.viewType;
  previewId.value = ssrInitialState.data.current.previewId;
}

// SEO - 在 setup 顶层使用 computed，数据更新后自动响应
// 注意：必须在数据恢复之后调用，否则会用空值覆盖 SSR 标题
useHead({
  title: computed(() => {
    if (materialArticlesInfo.value?.currentMaterial && columnInfo.value) {
      return `${materialArticlesInfo.value.currentMaterial.title} - ${columnInfo.value.columnName} - ${configInfo.value?.homeTitle || ''}`;
    }
    return '';
  }),
  meta: [
    {
      name: 'keywords',
      content: computed(() => columnInfo.value?.columnName || ''),
    },
    {
      name: 'description',
      content: computed(() => columnInfo.value?.digest || ''),
    },
  ],
});

// #endregion
</script>
<style scoped lang="scss">
@media screen and (device-width >= 1180px) {
  .no-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .main-wrap {
    padding-top: 15px;
  }

  .detail-title-container {
    width: 1200px;
    margin: 0 auto 18px;

    .detail-title-container-title {
      font-size: 20px;
      font-weight: 600;
      line-height: 2;
      color: #000;
      text-align: center;
    }

    .detail-title-container-time {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;
      color: rgb(0 0 0 / 60%);

      .time {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url('./image/date.png') no-repeat left center;
        background-size: auto 100%;
      }

      .read-count {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        margin-left: 20px;
        background: url('./image/eye.png') no-repeat left center;
        background-size: auto 100%;
      }
    }

    .detail-title-container-digest {
      padding: 10px;
      margin: 6px 0;
      font-size: 14px;
      line-height: 2;
      color: rgb(0 0 0 / 80%);
      background-color: #f4f4f5;
    }
  }

  .detail-content-container {
    width: 1200px;
    padding: 30px 40px;
    margin: 0 auto 28px;
    overflow: hidden;
    box-shadow: 0 0 6px rgb(35 52 78 / 30%);
  }

  .detail-pager-container {
    display: flex;
    width: 1200px;
    margin: 0 auto 28px;
    overflow: hidden;

    .detail-pager-container-pre,
    .detail-pager-container-next {
      max-width: 500px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      a {
        color: #008bd5;
      }
    }

    .detail-pager-container-blank {
      flex-grow: 1;
    }
  }
}
</style>
<style scoped lang="scss">
@media screen and (device-width <= 1180px) {
  .no-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .detail-title-container {
    padding: 0 3vw;
    font-size: 4vw;
    .detail-title-container-title {
      font-size: 5.2vw;
      font-weight: 600;
      line-height: 1.5em;
      color: #000;
    }

    .detail-title-container-time {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin: 3vw 0;
      color: rgb(0 0 0 / 80%);

      .time {
        display: inline-block;
        width: 5vw;
        height: 5vw;
        margin-right: 1vw;
        background: url('./image/date.png') no-repeat left center;
        background-size: auto 100%;
      }
      .read-count {
        display: inline-block;
        width: 5vw;
        height: 5vw;
        margin-right: 1vw;
        margin-left: 3vw;
        background: url('./image/eye.png') no-repeat left center;
        background-size: auto 100%;
      }
    }
    .detail-title-container-digest {
      padding: 2vw;
      margin: 4vw 0;
      font-size: 3.8vw;
      line-height: 2;
      color: rgb(0 0 0 / 60%);
      background-color: #f4f4f5;
    }
  }

  .detail-content-container {
    padding: 2vw;
    margin: 0 3vw;
    overflow: hidden;
    box-shadow: 0 0 6px rgb(35 52 78 / 30%);
  }

  .detail-pager-container {
    display: flex;
    flex-direction: row;
    margin: 3vw;
    font-size: 4vw;
    line-height: 2.5em;

    .detail-pager-container-pre,
    .detail-pager-container-next {
      width: calc(50% - 2vw);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      a {
        color: #008bd5;
      }
    }
    .detail-pager-container-blank {
      width: 4vw;
    }
  }
}
</style>
